import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  width: 100%;
  padding: 2rem;
  height: 91%;
  overflow-y: auto;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }

  .p-datatable-wrapper::-webkit-scrollbar {
    background-color: #c1c1c1;
    width: 4px;
    height: 7px;
  }

  .p-datatable-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .p-datatable-wrapper::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 10px;
  }

  .p-datatable .p-datatable-tbody > tr.p-highlight > td {
    color: #6e6b7b;
  }
`;

export const DivIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background: #fff;
  mix-blend-mode: normal;
`;
export const Img = styled.img`
  max-width: 90%;
  max-height: 90%;
`;

export const ImgFilter = styled.img`
  width: 1rem;
  position: absolute;
  top: 30%;
  left: 12px;
`;
interface IChip {
  bgColor?: string;
}
export const Chip = styled.div<IChip>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3.125rem;
  height: 2rem;
  width: 5.8125rem;
  background: ${(props) => (props.bgColor ? props.bgColor : " #EAEAEA")};
`;

export const HeaderTable = css`
  @media screen and (max-width: 599px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 0;
  }
`;

export const Options = css`
  @media screen and (max-width: 599px) {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }
`;
